import React, { createContext, useContext, useState, useEffect, useMemo } from "react";

const LanguageContext = createContext();

export const translations = {
  de: {
    nav: { products: "Produkte", about: "Story", team: "Partner", contact: "Kontakt" },
    hero: {
      kicker: "Torwarthandschuhe Schweiz · German Latex · Pro Quality",
      title_1: "Pro Grip.",
      title_2: "Pro Edition.",
      title_3: "4keeperz.",
      subtitle:
        "Premium Torwarthandschuhe – handgefertigt aus German Giga Grip Latex und Breathapren. Langer Grip, robust, fairer Preis. Goalkeeper Gloves Swiss Made. Gebaut by keeperz 4keeperz.",
      cta_primary: "Produkte entdecken",
      cta_secondary: "Unsere Story",
      badges: ["German Latex", "Breathapren Body", "Faire Preise"],
      badges_tip: "Klicken für Infos",
    },
    marquee: "4KEEPERZ · TORWARTHANDSCHUHE · GOALIE GLOVES · PRO GRIP · GIGA GRIP · SWISS BRAND · PRO LEVEL · ",
    featured: {
      kicker: "Die Kollektion",
      title: "Deine Waffen.",
      subtitle: "Hand verlesene Torwarthandschuhe und Goalkeeper-Essentials für Profis, Amateure, Damen und Junior-Keeper. Weitere Farben und Editionen folgen.",
      category_labels: {
        gloves: "Torwarthandschuhe",
        apparel: "Torwartbekleidung",
        accessories: "Zubehör",
      },
      filter_all: "Alle",
      coming_soon_title: "Coming Soon",
      coming_soon_text: "Wir entwickeln aktuell unsere Torwartbekleidung. Abonniere den Launch-Alert und sei der Erste, wenn es soweit ist.",
      colorway_label: "Colorway",
      more_colors: "Weitere Farben folgen",
    },
    product_card: {
      price_label: "UVP",
      prelaunch_cta: "Jetzt kaufen",
    },
    materials: {
      click_hint: "Mehr erfahren",
      compare_cta: "Latex vergleichen",
      german_latex: {
        title: "German Pro Latex",
        subtitle: "Made in Germany · 4mm Profi-Qualität",
        body_1:
          "Wir setzen ausschließlich auf hochwertige Latex-Compounds aus deutscher Fertigung. Zwei Varianten kommen bei 4keeperz zum Einsatz – beide 4mm dick, beide auf Profi-Niveau. Welche besser zu dir passt, hängt von deinem Spielstil und den Bedingungen ab.",
        body_2: "Unsere zwei Latex-Typen:",
        points: [
          "German Giga Grip – maximale Klebrigkeit, weicher Touch, Wet-Conditions Champion",
          "German Contact Grip – ausbalanciertes Allrounder-Latex, deutlich robuster",
          "Beide poröse Oberflächenstruktur für Mikro-Vakuum-Effekt",
          "Beide 4mm Dämpfung gegen harte Schüsse",
        ],
        footer: "Klicke auf 'Latex vergleichen' für die direkte Gegenüberstellung.",
      },
      neoprene: {
        title: "Breathapren Konstruktion",
        subtitle: "Full Breathapren Body · Punchingzone · Dual Stripe Verschluss",
        body_1:
          "Der komplette Handschuh ist aus Breathapren gefertigt – einer high-end Weiterentwicklung von klassischem Neopren. Atmungsaktiver, leichter und mit aktiver Feuchtigkeitsregulierung. Die Punchingzone auf den Finger-Oberseiten ist ediitions-abhängig: Mamba mit Silikon (härteste Rebound-Kontrolle), Panther mit New German Basic Latex (ausbalanciert, robuster).",
        body_2: "Die Vorteile:",
        points: [
          "Breathapren-Body: deutlich atmungsaktiver als Standard-Neopren",
          "Aktive Feuchtigkeitsregulierung – trockene Hand auch bei intensiven Spielen",
          "Mamba: Silikon-Punchingzone für knallharte Fauststöße",
          "Panther: New German Basic Latex Punchingzone für ausgewogenen Rebound",
          "Dual Stripe Verschluss: zwei separate Klettbänder für perfekten Sitz",
          "Stabilisiert das Handgelenk auch bei harten Paraden",
        ],
        footer: "Kombiniert mit Giga Grip Latex ergibt das den Handschuh, den du dir schon immer gewünscht hast.",
      },
    },
    latex_compare: {
      title: "Latex Vergleich",
      subtitle: "German Giga Grip vs German Contact Grip",
      intro: "Beide Latex-Typen sind 4mm German-made Profi-Qualität. Der Unterschied liegt im Charakter – wähle das Latex, das zu deinem Spielstil passt.",
      categories_label: "Performance-Profil",
      cards: [
        {
          key: "giga_grip",
          name: "German Giga Grip",
          edition: "Mamba Edition",
          tagline: "Maximum Stickiness",
          description:
            "Weicher, klebriger Latex mit explosivem Grip. Ideal bei Nässe und auf nassem Rasen. Etwas weniger abriebfest – der Trade-off für maximalen Grip.",
          best_for: "Pro-Keeper · Wet Conditions · Big Games",
        },
        {
          key: "contact_grip",
          name: "German Contact Grip",
          edition: "Panther Edition",
          tagline: "Balanced All-Rounder",
          description:
            "Ausgewogenes Latex mit hervorragender Balance zwischen Grip und Langlebigkeit. Sehr robust, perfekt für Training und Allwetter-Einsatz.",
          best_for: "Tägliches Training · Allwetter · Lange Haltbarkeit",
        },
      ],
      ratings: {
        wet: { label: "Nässe", giga: 5, contact: 4 },
        dry: { label: "Trocken", giga: 4, contact: 5 },
        cushioning: { label: "Dämpfung", giga: 4, contact: 4 },
        durability: { label: "Abrieb", giga: 3, contact: 5 },
      },
      footer: "Tipp: Hardcore Gameday-Keeper = Mamba (Giga Grip). Trainings-Beast oder All-Conditions Keeper = Panther (Contact Grip).",
    },
    rating_labels: {
      grip: "Grip",
      wet: "Nässe",
      dry: "Trocken",
      cushioning: "Dämpfung",
      durability: "Abrieb",
    },
    usps: {
      title: "Warum 4keeperz?",
      items: [
        { title: "German Pro Latex", text: "Zwei 4mm Profi-Latex-Typen aus Deutschland: Giga Grip für maximalen Grip, Contact Grip für robuste Allround-Performance." },
        { title: "Breathapren Body", text: "Atmungsaktiver High-End Breathapren-Handschuh mit Punchingzone (Mamba: Silikon, Panther: New German Basic Latex) und Dual Stripe Verschluss für perfekten Sitz." },
        { title: "Faire Preise", text: "Direkt vom 4Keeperz für 4Keeperz. Ohne Aufschläge durch große Marken." },
        { title: "Swiss Brand", text: "Gegründet von einem Torwart aus Liebe und Leidenschaft fürs Torwartspiel." },
      ],
    },
    founder: {
      kicker: "Der Gründer",
      name: "Segsan Gröschel",
      role: "Gründer & Torwart · FC Wädenswil",
    },
    story: {
      kicker: "Unsere Story",
      title: "By Keeperz For Keeperz.",
      paragraphs: [
        "Es beginnt in der Sekunde, in der der Ball fliegt. Puls hämmert. Zeit friert ein. Alles hängt an deinen Händen. Ich kenne dieses Gefühl. Ich lebe es. Und ich weiss: In diesem Moment darf dein Handschuh nicht zweifeln.",
        "Torwart zu sein ist keine Position. Es ist eine Entscheidung. Jeden Sonntag stehst du allein. Jeder Fehler wiegt schwerer. Jede Parade ist Erlösung. Genau diese Kompromisslosigkeit hat mich gepackt – und lässt mich bis heute nicht los.",
        "Feldspieler streiten über Schuhe. Wir streiten über Handschuhe. Sie sind unser Werkzeug, unsere Waffe, unsere Identität. Jahrelang habe ich gesucht – nach dem einen Paar, das nicht nach zwei Monaten weich wird, den Grip nicht verliert, nicht auseinanderfällt.",
        "Low-Budget, Mid-Range, Premium – ich habe alles durchgeprobt. Die Wahrheit? Auch die grossen Namen halten kein Versprechen ein. Also habe ich aufgehört zu suchen. Und angefangen zu bauen. Langlebiger. Kompromissloser Grip. Fairer Preis. Ohne Marketing-Bullshit.",
        "4keeperz ist keine Marke von Konzernen für Konsumenten. Wir sind Keeperz, die für Keeperz bauen. Street statt steril. Community statt Katalog. Wir schreiben die Regeln neu – Handschuh für Handschuh.",
      ],
      signature_tag: "by keeperz · for keeperz",
      stats: [
        { value: "4mm", label: "Giga Grip Latex" },
        { value: "100%", label: "4Keeperz Approved" },
        { value: "CH", label: "Swiss Brand" },
      ],
    },
    collab: {
      kicker: "R&D Partner · Pro-Feedback",
      name: "Ivan Bonfardin",
      role: "Ex-Profi Spieler · aktuell FC Uitikon 1. Mannschaft",
      clubs: "FC Zürich · Juventus Turin · FC Südtirol · YF Juventus · Rapperswil-Jona",
      headline: "Profi-Feedback. Direkt auf die Werkbank.",
      body: "Perfektion entsteht nicht allein. Deshalb entwickeln wir 4keeperz gemeinsam mit Ex-Profi Ivan Bonfardin. Sein Feedback aus dem Spitzenfussball – und vor allem sein Netzwerk zu Profi-Torhütern – fliesst direkt in die Produktion ein. Für die Entwicklung und Weiterentwicklung unserer Handschuhe ist das matchentscheidend.",
      quote: "Ein guter Handschuh entscheidet Spiele. Ein grossartiger entscheidet Karrieren.",
      badge: "Verified Pro Insight",
    },
    anatomy: {
      kicker: "Anatomie",
      title: "Anatomie eines 4keeperz Handschuhs.",
      subtitle: "Jedes Detail ist bewusst gewählt. Vom Latex bis zum Verschluss – hier siehst du, was einen Pro-Handschuh ausmacht.",
      edition_label: "Panther Edition · Contact Grip",
      features: [
        {
          key: "punch_zone",
          num: "01",
          name: "Punchingzone",
          text: "Verstärkte Zone über Fingern und Knöcheln. Bei der Panther Edition aus New German Basic Latex, bei der Mamba Edition aus Silikon. Maximale Härte für Fauststoss – der Ball springt kontrolliert, nicht wild ab.",
        },
        {
          key: "negative_cut",
          num: "02",
          name: "Negative Cut",
          text: "Innenfläche schmaler geschnitten als der Aussenhandschuh. Ergibt eine hautenge Passform und direktes Ballgefühl – Pro-Standard.",
        },
        {
          key: "breathapren",
          num: "03",
          name: "Breathapren Body",
          text: "High-End Weiterentwicklung von Neopren. Atmungsaktiv, leicht, mit aktiver Feuchtigkeitsregulierung.",
        },
        {
          key: "dual_stripe",
          num: "04",
          name: "Dual Stripe Verschluss",
          text: "Zweifach-Klettverschluss mit elastischem Band. Stabilisiert das Handgelenk, hält bei jeder Parade – kein Verrutschen, kein Nachziehen.",
        },
      ],
      dual_stripe_deep: {
        title: "Warum Dual Stripe?",
        subtitle: "Latex bis zum Handgelenk – nicht verdeckt vom Verschluss.",
        body: "Bei den meisten Marken verdeckt der breite Klettverschluss den ganzen Handgelenk-Bereich. Bei uns bleibt die Fangfläche voll nutzbar – jeder Zentimeter Latex arbeitet für dich. Der Zweifach-Verschluss stabilisiert trotzdem sicher, ohne wertvolle Grip-Fläche zu opfern.",
        open_label: "Offen · Latex voll sichtbar",
        closed_back_label: "Geschlossen · Rückseite",
        closed_palm_label: "Geschlossen · Fangfläche",
      },
    },
    cta_banner: {
      title: "Interesse geweckt?",
      subtitle: "Schreib uns – wir antworten meist innerhalb 24 Stunden.",
      button: "Jetzt Kontakt aufnehmen",
    },
    contact: {
      kicker: "Kontakt",
      title: "Sag Hallo.",
      subtitle: "Fragen, Feedback oder Händleranfragen? Wir hören zu.",
      name: "Name",
      email: "E-Mail",
      subject: "Betreff",
      message: "Nachricht",
      send: "Nachricht senden",
      sending: "Wird gesendet...",
      success: "Nachricht gesendet. Wir melden uns bald!",
      error: "Fehler beim Senden. Bitte versuche es erneut.",
      info_title: "Direkter Draht",
      location: "Eschenbach, Schweiz",
    },
    footer: { tagline: "Swiss Brand · Pro Quality · Giga Grip", rights: "Alle Rechte vorbehalten." },
    footer_legal: {
      title: "Rechtliches",
      blog: "Blog",
      imprint: "Impressum",
      privacy: "Datenschutz",
      terms: "AGB",
      shipping: "Versand & Rückgabe",
    },
    legal: {
      back: "← Zurück zur Startseite",
      last_updated: "Stand:",
      imprint: {
        title: "Impressum",
        sections: [
          {
            heading: "Angaben gemäß § 5 TMG / Art. 322 OR",
            body:
              "4keeperz\nSegsan Gröschel\nEschenbach, Schweiz\n\nE-Mail: info@4keeperz.ch\nUID/Handelsregister: [in Eintragung]",
          },
          {
            heading: "Verantwortlich für den Inhalt",
            body: "Segsan Gröschel\nEschenbach, Schweiz",
          },
          {
            heading: "Streitbeilegung",
            body:
              "Die EU-Kommission stellt eine Plattform zur Online-Streitbeilegung bereit (https://ec.europa.eu/consumers/odr). Wir sind nicht verpflichtet und nicht bereit, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.",
          },
          {
            heading: "Haftungsausschluss",
            body:
              "Trotz sorgfältiger inhaltlicher Kontrolle übernehmen wir keine Haftung für die Inhalte externer Links. Für den Inhalt verlinkter Seiten sind ausschließlich deren Betreiber verantwortlich.",
          },
        ],
      },
      privacy: {
        title: "Datenschutzerklärung",
        sections: [
          {
            heading: "1. Verantwortliche Stelle",
            body:
              "Verantwortlich im Sinne des schweizerischen Datenschutzgesetzes (DSG) und der EU-Datenschutz-Grundverordnung (DSGVO) ist:\n\n4keeperz\nSegsan Gröschel\nEschenbach, Schweiz\nE-Mail: info@4keeperz.ch",
          },
          {
            heading: "2. Erhebung und Verarbeitung von Daten",
            body:
              "Wir erheben personenbezogene Daten nur, soweit du sie uns selbst zur Verfügung stellst – z.B. beim Ausfüllen des Kontaktformulars oder bei einer Bestellung. Verarbeitet werden Name, E-Mail, Lieferadresse, Bestell- und Zahlungsdaten sowie ggf. weitere Eingaben.",
          },
          {
            heading: "3. Zweck der Verarbeitung",
            body:
              "Deine Daten verwenden wir ausschließlich zur Beantwortung deiner Anfrage sowie zur Abwicklung und Erfüllung deiner Bestellungen (inkl. Versand, Zahlungsabwicklung via Stripe und Kundenservice). Eine Weitergabe an Dritte erfolgt nicht ohne deine ausdrückliche Einwilligung – ausgenommen sind Dienstleister, die wir für den Betrieb benötigen (z.B. Versandpartner, Stripe für Zahlungen).",
          },
          {
            heading: "4. Cookies",
            body:
              "Diese Website verwendet ausschließlich technisch notwendige Cookies (z.B. Spracheinstellung, Warenkorb). Es findet kein Tracking durch Drittanbieter statt.",
          },
          {
            heading: "5. Deine Rechte",
            body:
              "Du hast das Recht auf Auskunft, Berichtigung, Löschung und Einschränkung der Verarbeitung deiner Daten. Schreib einfach an info@4keeperz.ch und wir kümmern uns innerhalb 14 Tagen darum.",
          },
          {
            heading: "6. Datensicherheit",
            body:
              "Die Übertragung deiner Daten erfolgt verschlüsselt via TLS/HTTPS. Wir setzen technische und organisatorische Maßnahmen ein, um deine Daten vor unbefugtem Zugriff zu schützen.",
          },
        ],
      },
      terms: {
        title: "Allgemeine Geschäftsbedingungen (AGB)",
        sections: [
          {
            heading: "1. Geltungsbereich",
            body:
              "Diese AGB gelten für alle Verträge, die zwischen 4keeperz (Segsan Gröschel, Eschenbach, Schweiz) und Kund:innen über den Online-Shop www.4keeperz.ch geschlossen werden.",
          },
          {
            heading: "2. Vertragsschluss",
            body:
              "Die Darstellung der Produkte stellt kein bindendes Angebot dar. Mit dem Klick auf den Bestell-Button gibst du ein verbindliches Angebot ab. Der Vertrag kommt mit unserer Auftragsbestätigung per E-Mail zustande.",
          },
          {
            heading: "3. Preise & Versand",
            body:
              "Alle Preise verstehen sich inkl. der jeweils gültigen MwSt.\n\n🇨🇭 Schweiz & 🇱🇮 Liechtenstein: Preise in Schweizer Franken (CHF). Versandkosten CHF 8 (Standard), ab Bestellwert CHF 80 kostenlos.\n\n🇩🇪 Deutschland & 🇦🇹 Österreich: Preise in Euro (EUR). Versandkosten EUR 8,50 (Standard), ab Bestellwert EUR 84 kostenlos. Der Versand für DE/AT-Bestellungen erfolgt aus unserem Lager in Deutschland.\n\nDie Region-Umschaltung findest du im Warenkorb.",
          },
          {
            heading: "4. Lieferung",
            body:
              "Bestellungen werden innerhalb von 1 Werktag versendet. Lieferzeiten:\n• Schweiz & Liechtenstein: 2–4 Werktage (Schweizerische Post)\n• Deutschland: 3–5 Werktage (DHL/DPD)\n• Österreich: 3–5 Werktage (DHL/DPD)\n\nBei Verzögerungen im Transport informieren wir dich per E-Mail. Eine Sendungsnummer erhältst du automatisch nach Versand.",
          },
          {
            heading: "5. Zahlung",
            body:
              "Wir akzeptieren Kreditkarten (Visa, Mastercard, American Express), TWINT, Apple Pay und Google Pay. Die Zahlung erfolgt sicher über Stripe (SSL-verschlüsselt). Es fallen keine zusätzlichen Gebühren an.",
          },
          {
            heading: "6. Widerrufsrecht & Rückgabe",
            body:
              "Du kannst deine Bestellung innerhalb von 14 Tagen nach Erhalt ohne Angabe von Gründen zurückgeben. Voraussetzung: Die Ware ist ungetragen, in Originalverpackung und ohne Trage- oder Gebrauchsspuren. Rücksendungen bitte unfrei an unsere Adresse senden – die Rücksendekosten trägst du. Bei Mängeln übernehmen wir die Rücksendekosten.",
          },
          {
            heading: "7. Gewährleistung",
            body:
              "Es gelten die gesetzlichen Gewährleistungsrechte gemäß OR. Reklamationen bitte mit Foto-Beweis und Bestellnummer an info@4keeperz.ch.",
          },
          {
            heading: "8. Anwendbares Recht & Gerichtsstand",
            body:
              "Es gilt schweizerisches Recht unter Ausschluss des UN-Kaufrechts. Gerichtsstand ist – soweit gesetzlich zulässig – Eschenbach, Schweiz.",
          },
        ],
      },
      shipping: {
        title: "Versand & Rückgabe",
        sections: [
          {
            heading: "Lieferzeiten & Bearbeitung",
            body:
              "Bestellungen werden in der Regel innerhalb von 1 Werktag versendet. Du erhältst eine Sendungsnummer per E-Mail, sobald dein Paket auf dem Weg ist.\n\n• Schweiz & Liechtenstein: 2–4 Werktage (Schweizerische Post)\n• Deutschland: 3–5 Werktage (Versand ab unserem Lager in Deutschland via DHL/DPD)\n• Österreich: 3–5 Werktage (Versand via DHL/DPD)",
          },
          {
            heading: "Versandkosten",
            body:
              "🇨🇭 Schweiz\n• Standard: CHF 8\n• Kostenlos ab Bestellwert CHF 80\n\n🇱🇮 Liechtenstein\n• Standard: CHF 8\n• Kostenlos ab Bestellwert CHF 80\n\n🇩🇪 Deutschland\n• Standard: EUR 8,50\n• Kostenlos ab Bestellwert EUR 84\n\n🇦🇹 Österreich\n• Standard: EUR 8,50\n• Kostenlos ab Bestellwert EUR 84\n\nAndere EU-Länder auf Anfrage.",
          },
          {
            heading: "Bezahlung",
            body:
              "Wir akzeptieren Kredit- und Debitkarten (Visa, Mastercard, American Express) sowie TWINT (Schweiz) über unseren zertifizierten Zahlungspartner Stripe. Für DE- und AT-Bestellungen bezahlst du in EUR, für CH- und LI-Bestellungen in CHF – die Region-Umschaltung findest du im Warenkorb.",
          },
          {
            heading: "Rückgabe",
            body:
              "14 Tage Rückgaberecht ab Erhalt der Ware. Voraussetzungen:\n• Ware ungetragen und in Originalverpackung\n• Keine Trage-, Pflege- oder Schweißspuren\n• Etiketten unbeschädigt\n\nMelde deine Rückgabe per E-Mail an info@4keeperz.ch an. Wir senden dir die passende Rücksendeadresse (Schweiz für CH/LI-Bestellungen, Deutschland für DE/AT-Bestellungen). Die Rücksendekosten trägst du selbst – bei Mängeln oder Falschlieferung übernehmen wir diese.",
          },
          {
            heading: "Erstattung",
            body:
              "Nach Eingang und Prüfung der Rücksendung erstatten wir den Kaufpreis innerhalb von 5 Werktagen auf das ursprüngliche Zahlungsmittel. Bei Teilrücksendungen werden die anteiligen Versandkosten nicht erstattet – bei vollständiger Rückgabe erstatten wir die Versandkosten mit.",
          },
          {
            heading: "Mängel & Reklamation",
            body:
              "Solltest du einen Mangel an deinen Handschuhen feststellen, melde dich umgehend mit Foto und Bestellnummer bei info@4keeperz.ch. Wir kümmern uns innerhalb 48 Stunden um eine Lösung – Ersatz oder Rückerstattung. Die Rücksendekosten übernehmen wir bei berechtigten Reklamationen komplett.",
          },
        ],
      },
    },
    size_guide: {
      cta: "Größenguide",
      title: "Größenguide",
      subtitle: "Offizielle Herstellermaße — 4keeperz Fit",
      intro: "Miss die Breite deiner dominanten Hand an der breitesten Stelle (unter den Fingern, ohne Daumen) und die Länge vom Handgelenk bis zur Fingerspitze des Mittelfingers. Vergleiche mit der Tabelle und wähle die passende Größe.",
      columns: ["Größe", "Handbreite", "Handlänge", "Empfehlung"],
      rows: [
        { size: "7", hand_width: "11 cm", hand_length: "18,5 cm", audience: "Junior / Damen" },
        { size: "8", hand_width: "11 cm", hand_length: "19,5 cm", audience: "Junior / Damen" },
        { size: "9", hand_width: "11,5 cm", hand_length: "20 cm", audience: "Standard Herren" },
        { size: "10", hand_width: "12 cm", hand_length: "20,5 cm", audience: "Standard Herren" },
        { size: "11", hand_width: "12,5 cm", hand_length: "21 cm", audience: "Große Hände" },
      ],
      tip: "Tipp: Im Zweifel lieber die nächstkleinere Größe – die Handschuhe dehnen sich mit dem Tragen leicht aus. Ein zu großer Handschuh kostet Grip und Kontrolle.",
      measure_hint: "So misst du richtig",
      measure_steps: [
        "Lege deine Hand flach auf ein Blatt Papier, Finger geschlossen (ohne Daumen).",
        "Miss die Breite an der breitesten Stelle direkt unterhalb der Finger.",
        "Miss die Länge vom Handgelenk-Ansatz bis zur Spitze des Mittelfingers.",
      ],
    },
    price_comparison: {
      title: "Preisvergleich",
      subtitle: "Vergleichbare Pro-Spezifikationen – zum Bruchteil des Preises.",
      intro: "Die großen Marken investieren massiv in Marketing, Sponsoring und Zwischenhändler. Wir investieren in Material. Gleiche Latex-Qualität, gleiche Profi-Specs – ohne den Marken-Aufschlag.",
      columns: ["Segment", "UVP-Spanne", "Differenz zu 4keeperz"],
      rows: [
        { segment: "Premium Top-Tier", price: "CHF 200–230", diff: "+101 bis +131" },
        { segment: "Premium Mid-Tier", price: "CHF 170–200", diff: "+71 bis +101" },
        { segment: "Premium Einstieg", price: "CHF 140–170", diff: "+41 bis +71" },
      ],
      average_label: "Marktdurchschnitt Premium-Handschuh",
      average_price: "≈ CHF 180",
      ours_label: "4keeperz Panther",
      ours_price: "CHF 109",
      ours_note: "Gleicher 4mm German Contact Grip Latex. Gleiche Pro-Features. Nur ehrlicher Preis.",
      footer: "Preise Referenz: Durchschnittliche UVP-Preise aus dem Schweizer Torwart-Handschuh-Markt, Erhebungszeitraum 2026. Einzelne Modelle können im Sale günstiger sein – wir liefern den fairen Preis direkt ganzjährig.",
      cta: "Preise vergleichen",
    },
    prelaunch_counter: {
      label: "Keeperz auf der Liste",
      loading: "...",
    },
    close: "Schließen",
  },
  en: {
    nav: { products: "Products", about: "Story", team: "Partners", contact: "Contact" },
    hero: {
      kicker: "Goalkeeper Gloves Switzerland · German Latex · Pro Quality",
      title_1: "Pro Grip.",
      title_2: "Pro Edition.",
      title_3: "4keeperz.",
      subtitle:
        "Premium goalkeeper gloves – handcrafted with German Giga Grip latex and Breathapren. Long grip, rugged, fair price. Swiss Made. Built by keeperz 4keeperz.",
      cta_primary: "Explore products",
      cta_secondary: "Our story",
      badges: ["German Latex", "Breathapren Body", "Fair Pricing"],
      badges_tip: "Click for details",
    },
    marquee: "4KEEPERZ · GOALKEEPER GLOVES · TORWARTHANDSCHUHE · PRO GRIP · GIGA GRIP · SWISS BRAND · PRO LEVEL · ",
    featured: {
      kicker: "The Collection",
      title: "Your Weapons.",
      subtitle: "Hand-picked goalkeeper gloves and essentials for pros, amateurs, women and junior keepers. More colors and editions coming.",
      category_labels: {
        gloves: "Goalkeeper Gloves",
        apparel: "Goalkeeper Apparel",
        accessories: "Accessories",
      },
      filter_all: "All",
      coming_soon_title: "Coming Soon",
      coming_soon_text: "We're currently developing our goalkeeper apparel. Sign up for the launch alert and be the first to know.",
      colorway_label: "Colorway",
      more_colors: "More colors coming",
    },
    product_card: { price_label: "MSRP", prelaunch_cta: "Buy now" },
    materials: {
      click_hint: "Learn more",
      compare_cta: "Compare latex",
      german_latex: {
        title: "German Pro Latex",
        subtitle: "Made in Germany · 4mm pro grade",
        body_1:
          "We exclusively use high-grade latex compounds manufactured in Germany. Two variants are used at 4keeperz – both 4mm thick, both pro level. Which one fits you best depends on your style and the conditions.",
        body_2: "Our two latex types:",
        points: [
          "German Giga Grip – maximum stickiness, soft touch, wet-conditions champion",
          "German Contact Grip – balanced all-rounder, noticeably more durable",
          "Both feature a porous surface for the micro-vacuum grip effect",
          "Both 4mm thick for shock absorption on hard shots",
        ],
        footer: "Click 'Compare latex' for a direct side-by-side breakdown.",
      },
      neoprene: {
        title: "Breathapren Construction",
        subtitle: "Full Breathapren Body · Punch Zone · Dual Stripe Closure",
        body_1:
          "The entire glove is crafted from Breathapren – a high-end evolution of classic neoprene. More breathable, lighter and with active moisture regulation. The punch zone on the finger backs is edition-specific: Mamba uses silicone (hardest rebound control), Panther uses New German Basic Latex (balanced, more durable).",
        body_2: "The benefits:",
        points: [
          "Breathapren body: noticeably more breathable than standard neoprene",
          "Active moisture management – dry hand even on intense matches",
          "Mamba: silicone punch zone for rock-solid fisted saves",
          "Panther: New German Basic Latex punch zone for balanced rebound",
          "Dual Stripe closure: two separate velcro straps for a perfect fit",
          "Stabilizes the wrist even on hard parries",
        ],
        footer: "Combined with Giga Grip latex, it delivers the glove you've always wanted.",
      },
    },
    latex_compare: {
      title: "Latex Comparison",
      subtitle: "German Giga Grip vs German Contact Grip",
      intro: "Both latex types are 4mm German-made pro quality. The difference is in character – pick the one that fits your game.",
      categories_label: "Performance Profile",
      cards: [
        {
          key: "giga_grip",
          name: "German Giga Grip",
          edition: "Mamba Edition",
          tagline: "Maximum Stickiness",
          description:
            "Soft, sticky latex with explosive grip. Ideal in rain and on wet pitches. Slightly less abrasion-resistant – the trade-off for maximum grip.",
          best_for: "Pro keeper · Wet conditions · Big games",
        },
        {
          key: "contact_grip",
          name: "German Contact Grip",
          edition: "Panther Edition",
          tagline: "Balanced All-Rounder",
          description:
            "Balanced latex with an excellent grip-to-durability ratio. Very rugged, perfect for training and all-weather use.",
          best_for: "Daily training · All-weather · Long lifespan",
        },
      ],
      ratings: {
        wet: { label: "Wet", giga: 5, contact: 4 },
        dry: { label: "Dry", giga: 4, contact: 5 },
        cushioning: { label: "Cushion", giga: 4, contact: 4 },
        durability: { label: "Durability", giga: 3, contact: 5 },
      },
      footer: "Tip: Hardcore gameday keeper = Mamba (Giga Grip). Training beast or all-conditions keeper = Panther (Contact Grip).",
    },
    rating_labels: {
      grip: "Grip",
      wet: "Wet",
      dry: "Dry",
      cushioning: "Cushion",
      durability: "Durability",
    },
    usps: {
      title: "Why 4keeperz?",
      items: [
        { title: "German Pro Latex", text: "Two 4mm pro-grade German latex types: Giga Grip for maximum stickiness, Contact Grip for rugged all-round performance." },
        { title: "Breathapren Body", text: "Breathable high-end Breathapren glove with punch zone (Mamba: silicone, Panther: New German Basic Latex) and Dual Stripe closure for a perfect fit." },
        { title: "Fair Pricing", text: "From keepers, for keepers. No markup from big-name brands." },
        { title: "Swiss Brand", text: "Founded by a goalkeeper out of pure love and passion for the goalkeeping craft." },
      ],
    },
    founder: {
      kicker: "The Founder",
      name: "Segsan Gröschel",
      role: "Founder & Goalkeeper · FC Wädenswil",
    },
    story: {
      kicker: "Our Story",
      title: "By Keeperz For Keeperz.",
      paragraphs: [
        "It starts the second the ball leaves the boot. Pulse hammering. Time frozen. Everything comes down to your hands. I know that feeling. I live it. And I know one thing: in that moment your gloves aren't allowed to hesitate.",
        "Being a keeper isn't a position. It's a decision. Every Sunday you stand alone. Every mistake weighs heavier. Every save is release. That uncompromising nature is what pulled me in — and hasn't let go since.",
        "Outfielders argue about boots. We argue about gloves. They're our tool, our weapon, our identity. For years I searched — for the one pair that doesn't go soft after two months, doesn't lose its grip, doesn't fall apart.",
        "Low-budget, mid-range, premium — I've been through them all. The truth? Even the big names don't keep their promises. So I stopped searching. And started building. More durable. Uncompromising grip. Fair pricing. No marketing bullshit.",
        "4keeperz isn't a brand made by corporations for consumers. We're keeperz building for keeperz. Street over sterile. Community over catalogue. We're rewriting the rules — glove by glove.",
      ],
      signature_tag: "by keeperz · for keeperz",
      stats: [
        { value: "4mm", label: "Giga Grip Latex" },
        { value: "100%", label: "Keeper Approved" },
        { value: "CH", label: "Swiss Brand" },
      ],
    },
    collab: {
      kicker: "R&D Partner · Pro Feedback",
      name: "Ivan Bonfardin",
      role: "Ex-Pro Player · currently FC Uitikon 1st Team",
      clubs: "FC Zürich · Juventus Turin · FC Südtirol · YF Juventus · Rapperswil-Jona",
      headline: "Pro feedback. Straight to the workbench.",
      body: "Perfection doesn't happen alone. That's why we build 4keeperz together with ex-pro Ivan Bonfardin. His feedback from top-flight football — and above all his network to professional goalkeepers — flows directly into our production. For the development and continuous evolution of our gloves, this is match-deciding.",
      quote: "A good glove wins matches. A great one shapes careers.",
      badge: "Verified Pro Insight",
    },
    anatomy: {
      kicker: "Anatomy",
      title: "Anatomy of a 4keeperz glove.",
      subtitle: "Every detail is intentional. From latex to closure – here's what makes a pro-level glove.",
      edition_label: "Panther Edition · Contact Grip",
      features: [
        {
          key: "punch_zone",
          num: "01",
          name: "Punch Zone",
          text: "Reinforced zone over fingers and knuckles. Panther Edition uses New German Basic Latex, Mamba Edition uses silicone. Maximum hardness for fisted saves — the ball rebounds controlled, not wild.",
        },
        {
          key: "negative_cut",
          num: "02",
          name: "Negative Cut",
          text: "Inner palm cut smaller than the outer shell. Delivers a skin-tight fit and direct ball feel — the pro-level standard.",
        },
        {
          key: "breathapren",
          num: "03",
          name: "Breathapren Body",
          text: "High-end evolution of neoprene. Breathable, lightweight, with active moisture regulation.",
        },
        {
          key: "dual_stripe",
          num: "04",
          name: "Dual Stripe Closure",
          text: "Twin velcro system with elastic band. Locks the wrist, holds through every save — no slip, no re-strapping.",
        },
      ],
      dual_stripe_deep: {
        title: "Why Dual Stripe?",
        subtitle: "Latex right down to the wrist — not covered by the closure.",
        body: "Most brands cover the entire wrist area with a wide velcro strap. Ours keeps the full catching surface usable — every centimetre of latex works for you. The twin-strap system still locks the wrist securely, without sacrificing valuable grip area.",
        open_label: "Open · full latex visible",
        closed_back_label: "Closed · backhand",
        closed_palm_label: "Closed · catching surface",
      },
    },
    cta_banner: {
      title: "Interested?",
      subtitle: "Drop us a line — we usually reply within 24 hours.",
      button: "Get in touch",
    },
    contact: {
      kicker: "Contact",
      title: "Say hello.",
      subtitle: "Questions, feedback or retailer inquiries? We're listening.",
      name: "Name",
      email: "Email",
      subject: "Subject",
      message: "Message",
      send: "Send message",
      sending: "Sending...",
      success: "Message sent. We'll get back to you soon!",
      error: "Failed to send. Please try again.",
      info_title: "Direct line",
      location: "Eschenbach, Switzerland",
    },
    footer: { tagline: "Swiss Brand · Pro Quality · Giga Grip", rights: "All rights reserved." },
    footer_legal: {
      title: "Legal",
      blog: "Blog",
      imprint: "Imprint",
      privacy: "Privacy",
      terms: "Terms",
      shipping: "Shipping & Returns",
    },
    legal: {
      back: "← Back to home",
      last_updated: "Last updated:",
      imprint: {
        title: "Imprint",
        sections: [
          { heading: "Company information", body: "4keeperz\nSegsan Gröschel\nEschenbach, Switzerland\n\nEmail: info@4keeperz.ch\nUID/Trade register: [pending]" },
          { heading: "Responsible for content", body: "Segsan Gröschel\nEschenbach, Switzerland" },
          { heading: "Disclaimer", body: "Despite careful content control, we assume no liability for the content of external links. The operators of linked pages are solely responsible for their content." },
        ],
      },
      privacy: {
        title: "Privacy Policy",
        sections: [
          { heading: "1. Controller", body: "Controller within the meaning of the Swiss Data Protection Act (DSG) and the EU GDPR is:\n\n4keeperz\nSegsan Gröschel\nEschenbach, Switzerland\nEmail: info@4keeperz.ch" },
          { heading: "2. Data collection", body: "We only collect personal data that you provide yourself – e.g. via the contact form or when placing an order. We process name, email, shipping address, order and payment data and other entries you submit." },
          { heading: "3. Purpose", body: "Your data is used exclusively to answer your inquiry, fulfill orders, and – upon signup – send launch updates. Data is not shared with third parties without your explicit consent." },
          { heading: "4. Cookies", body: "This website uses only technically necessary cookies (e.g. language setting, cart). No third-party tracking takes place." },
          { heading: "5. Your rights", body: "You have the right to access, correct, delete and restrict the processing of your data. Just write to info@4keeperz.ch and we'll handle it within 14 days." },
          { heading: "6. Data security", body: "Your data is transmitted encrypted via TLS/HTTPS. We employ technical and organizational measures to protect your data from unauthorized access." },
        ],
      },
      terms: {
        title: "Terms & Conditions",
        sections: [
          { heading: "1. Scope", body: "These terms apply to all contracts concluded between 4keeperz (Segsan Gröschel, Eschenbach, Switzerland) and customers via the online shop www.4keeperz.ch." },
          { heading: "2. Contract conclusion", body: "Product displays are not binding offers. By clicking the order button you submit a binding offer. The contract is concluded with our order confirmation by email." },
          { heading: "3. Prices & shipping", body: "All prices include applicable VAT.\n\n🇨🇭 Switzerland & 🇱🇮 Liechtenstein: prices in Swiss Francs (CHF). Shipping CHF 8 (standard), free above CHF 80.\n\n🇩🇪 Germany & 🇦🇹 Austria: prices in Euros (EUR). Shipping EUR 8.50 (standard), free above EUR 84. DE/AT orders ship from our warehouse in Germany.\n\nYou can switch region in the cart." },
          { heading: "4. Delivery", body: "Orders ship within 1 working day. Delivery times:\n• Switzerland & Liechtenstein: 2–4 working days (Swiss Post)\n• Germany: 3–5 working days (DHL/DPD)\n• Austria: 3–5 working days (DHL/DPD)\n\nWe'll notify you by email if there are any transport delays. You receive a tracking number automatically after shipment." },
          { heading: "5. Payment", body: "We accept credit cards (Visa, Mastercard, American Express), TWINT, Apple Pay and Google Pay. Payment is processed securely via Stripe (SSL-encrypted). No additional fees apply." },
          { heading: "6. Right of withdrawal & returns", body: "You may return your order within 14 days of receipt without giving reasons. Conditions: unworn, original packaging, no usage marks. Send returns prepaid to our address – return shipping costs are yours. We cover return shipping for defective items." },
          { heading: "7. Warranty", body: "Statutory warranty rights under Swiss law (OR) apply. Please send complaints with photo proof and order number to info@4keeperz.ch." },
          { heading: "8. Applicable law & jurisdiction", body: "Swiss law applies, excluding the UN Convention on Contracts for the International Sale of Goods. Place of jurisdiction is – where legally permissible – Eschenbach, Switzerland." },
        ],
      },
      shipping: {
        title: "Shipping & Returns",
        sections: [
          { heading: "Delivery times & processing", body: "Orders usually ship within 1 working day. You receive a tracking number by email once your package is on its way.\n\n• Switzerland & Liechtenstein: 2–4 working days (Swiss Post)\n• Germany: 3–5 working days (DHL/DPD, shipping from our warehouse in Germany)\n• Austria: 3–5 working days (DHL/DPD)" },
          { heading: "Shipping costs", body: "🇨🇭 Switzerland\n• Standard: CHF 8\n• Free above CHF 80\n\n🇱🇮 Liechtenstein\n• Standard: CHF 8\n• Free above CHF 80\n\n🇩🇪 Germany\n• Standard: EUR 8.50\n• Free above EUR 84\n\n🇦🇹 Austria\n• Standard: EUR 8.50\n• Free above EUR 84\n\nOther EU countries on request." },
          { heading: "Payment", body: "We accept credit and debit cards (Visa, Mastercard, American Express) and TWINT (Switzerland) via our certified payment partner Stripe. DE and AT orders are billed in EUR, CH and LI orders in CHF – you can switch region in the cart." },
          { heading: "Returns", body: "14-day return policy from receipt of goods. Conditions:\n• Unworn and in original packaging\n• No wear, care or sweat marks\n• Tags intact\n\nReport your return by email to info@4keeperz.ch. We'll send you the correct return address (Switzerland for CH/LI orders, Germany for DE/AT orders). Return shipping is at your cost – we cover it for defective items or wrong deliveries." },
          { heading: "Refund", body: "After receipt and inspection of your return, we refund the purchase price within 5 working days to the original payment method. For partial returns, proportional shipping costs are not refunded – for full returns we refund the shipping costs too." },
          { heading: "Defects & complaints", body: "If you discover a defect, contact us immediately with photo and order number at info@4keeperz.ch. We'll respond within 48 hours — replacement or refund. We cover the return shipping in full for justified complaints." },
        ],
      },
    },
    size_guide: {
      cta: "Size Guide",
      title: "Size Guide",
      subtitle: "Official manufacturer measurements — 4keeperz fit",
      intro: "Measure the width of your dominant hand at the widest point (just below the fingers, excluding the thumb) and the length from your wrist to the tip of your middle finger. Match against the table and pick the right size.",
      columns: ["Size", "Hand width", "Hand length", "Recommended for"],
      rows: [
        { size: "7", hand_width: "11 cm", hand_length: "18.5 cm", audience: "Junior / Women" },
        { size: "8", hand_width: "11 cm", hand_length: "19.5 cm", audience: "Junior / Women" },
        { size: "9", hand_width: "11.5 cm", hand_length: "20 cm", audience: "Standard Men" },
        { size: "10", hand_width: "12 cm", hand_length: "20.5 cm", audience: "Standard Men" },
        { size: "11", hand_width: "12.5 cm", hand_length: "21 cm", audience: "Large hands" },
      ],
      tip: "Tip: If in doubt go one size smaller — the gloves stretch slightly with wear. A glove that's too big costs grip and control.",
      measure_hint: "How to measure correctly",
      measure_steps: [
        "Place your hand flat on a sheet of paper, fingers closed (thumb aside).",
        "Measure the width at the widest point just below the fingers.",
        "Measure the length from the wrist crease to the tip of the middle finger.",
      ],
    },
    price_comparison: {
      title: "Price Comparison",
      subtitle: "Matching pro specs — at a fraction of the price.",
      intro: "The big brands spend massively on marketing, sponsorships and middlemen. We invest in materials. Same latex grade, same pro specs — without the brand markup.",
      columns: ["Segment", "MSRP Range", "Difference vs 4keeperz"],
      rows: [
        { segment: "Premium Top-Tier", price: "CHF 200–230", diff: "+101 to +131" },
        { segment: "Premium Mid-Tier", price: "CHF 170–200", diff: "+71 to +101" },
        { segment: "Premium Entry", price: "CHF 140–170", diff: "+41 to +71" },
      ],
      average_label: "Market average premium glove",
      average_price: "≈ CHF 180",
      ours_label: "4keeperz Panther",
      ours_price: "CHF 109",
      ours_note: "Same 4mm German Contact Grip latex. Same pro features. Just an honest price.",
      footer: "Price reference: average MSRP across the Swiss goalkeeper glove market, observation period 2026. Individual models can be cheaper on sale — we ship the fair price directly, year-round.",
      cta: "Compare prices",
    },
    prelaunch_counter: {
      label: "Keeperz on the list",
      loading: "...",
    },
    close: "Close",
  },
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("4k_lang") || "de");

  useEffect(() => {
    localStorage.setItem("4k_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = translations[lang];
  const value = useMemo(() => ({ lang, setLang, t }), [lang, t]);
  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLanguage = () => useContext(LanguageContext);
